import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import { ellipsis } from 'polished'
import contextSportsHeader, {
  SportsHeaderContextType,
} from '@contexts/sportsHeader'
import { VerticalRankingItemProps } from '@widgets/Teaser/sportsHeader/types'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { ViewportTypeValues } from '@contexts/viewport'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledItemPositionProps = Pick<SportsHeaderContextType, 'teaserFlex'>
type StyledItemNameProps = Pick<SportsHeaderContextType, 'teaserFlex'>
type StyledItemTimeProps = Pick<SportsHeaderContextType, 'teaserFlex'>

const { SportsHeaderContext } = contextSportsHeader

const StyledItemPosition = styled.div<StyledItemPositionProps>`
  justify-self: flex-start;
  ${({
    theme: {
      colors: { white },
      fonts: { goodOT: goodOTFontName },
    },
    teaserFlex,
  }) => {
    let fontSizeDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '2') {
      fontSizeDesktop = `${0.04375 * teaserWidthDesktop}px`
    }

    return css`
      color: ${white};
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      line-height: 1.214;
      font-weight: 900;
      ${desktopCSS(css`
        ${desktopTeaserFlex === '2'
          ? css`
              font-size: ${fontSizeDesktop};
            `
          : css`
              display: none;
            `}
      `)}

      ${tabletCSS(css`
        display: none;
      `)}

      ${mobileCSS(css`
        font-size: 3.734vw;
      `)}
    `
  }}
`

const StyledItemName = styled.div<StyledItemNameProps>`
  justify-self: flex-start;
  ${ellipsis('100%', 1)};
  ${({
    theme: {
      colors: { white },
      fonts: { goodOT: goodOTFontName },
    },
    teaserFlex,
  }) => {
    let fontSizeDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '2') {
      fontSizeDesktop = `${0.04375 * teaserWidthDesktop}px`
    }

    return css`
      color: ${white};
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      line-height: 1.214;
      font-weight: 900;
      ${desktopCSS(css`
        ${desktopTeaserFlex === '2'
          ? css`
              font-size: ${fontSizeDesktop};
            `
          : css`
              display: none;
            `}
      `)}

      ${tabletCSS(css`
        display: none;
      `)}

      ${mobileCSS(css`
        font-size: 3.734vw;
      `)}
    `
  }}
`

const StyledItemTime = styled.div<StyledItemTimeProps>`
  justify-self: flex-end;
  ${({
    theme: {
      colors: { white },
      fonts: { goodOT: goodOTFontName },
    },
    teaserFlex,
  }) => {
    let fontSizeDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '2') {
      fontSizeDesktop = `${0.04375 * teaserWidthDesktop}px`
    }

    return css`
      color: ${white};
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      line-height: 1.214;
      font-weight: 500;
      padding-left: 20px;
      ${desktopCSS(css`
        ${desktopTeaserFlex === '2'
          ? css`
              font-size: ${fontSizeDesktop};
            `
          : css`
              display: none;
            `}
      `)}

      ${tabletCSS(css`
        display: none;
      `)}

      ${mobileCSS(css`
        font-size: 3.734vw;
      `)}
    `
  }}
`

const VerticalRankingItem: FunctionComponent<VerticalRankingItemProps> = ({
  competitor: { position, name, time },
}) => {
  const { teaserFlex } = useContext(SportsHeaderContext)

  return (
    <>
      <StyledItemPosition teaserFlex={teaserFlex}>
        {position}.
      </StyledItemPosition>
      <StyledItemName teaserFlex={teaserFlex}>{name}</StyledItemName>
      <StyledItemTime teaserFlex={teaserFlex}>{time}</StyledItemTime>
    </>
  )
}

export default VerticalRankingItem
